import { render, staticRenderFns } from "./StatusTextDetail.vue?vue&type=template&id=7fe7542c&scoped=true&"
import script from "./StatusTextDetail.vue?vue&type=script&lang=js&"
export * from "./StatusTextDetail.vue?vue&type=script&lang=js&"
import style0 from "./StatusTextDetail.vue?vue&type=style&index=0&id=7fe7542c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe7542c",
  null
  
)

export default component.exports